import React, { useState, useMemo } from "react";
import PropTypes from "prop-types";
import styles from "./IBOAccountList.module.css";
import { v4 } from "uuid";

import IBOAccountItem from "../IBOAccountItem";

/**
 * View component.
 * Displays a list of accounts that an IBO has.
 */
export function IBOAccountList({ accounts, openModal }) {
  const idList = useMemo(
    () =>
      accounts.map((account) => {
        return { ...account, id: v4() };
      }),
    [accounts]
  );

  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <div>Platform</div>
        <div>Date Updated</div>
        <div>Status</div>
        <div />
      </div>

      <ul className={styles.list}>
        {idList.map((item, index) => (
          <li key={item.id}>
            <IBOAccountItem index={index} account={item} onChange={openModal} />
          </li>
        ))}
      </ul>
    </div>
  );
}

IBOAccountList.propTypes = {
  /**
   * Array of objects with the account's info.
   */
  accounts: PropTypes.arrayOf(
    PropTypes.shape({
      platform: PropTypes.string,
      dateEnrolled: PropTypes.string,
      status: PropTypes.string,
      reason: PropTypes.string,
    })
  ),
};
